module.exports = {"140728001":"古城街道","140728002":"城东街道","140728003":"城西街道","140728100":"古陶镇","140728101":"段村镇","140728102":"东泉镇","140728103":"洪善镇","140728104":"宁固镇","140728200":"南政乡","140728201":"中都乡","140728202":"岳壁乡","140728203":"卜宜乡","140728205":"朱坑乡","140728206":"襄垣乡","140728207":"杜家庄乡","140728208":"香乐乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/140728.json
// module id = 418
// module chunks = 0